import dashboard from '../dashboard';
import widget from '../widget';
import events from '../events';
import forms from '../forms';
import elements from '../elements';
import pages from '../pages';
import utilities from '../utilities';
import support from '../support';
import other from '../other';
import adminDashboard from './dashboard';

// ==============================|| MENU ITEMS ||============================== //

const adminItems = {
    // items: [dashboard, widget, application, forms, elements, pages, utilities, support, other]
    items: [adminDashboard]
};

export default adminItems;
